import { Expose, Transform, Type } from 'class-transformer';
import { Model } from './model';
import { TranslatedObjectModel } from './translated-object-model';

export class SurveysReport extends Model {
  @Expose() id: string;
  @Expose() status: string;
  @Expose() canceled: number;
  @Expose()
  @Transform(({ obj }) => (obj && obj?.surveyName && obj?.surveyName?.name ? obj.surveyName.name : null))
  @Type(() => TranslatedObjectModel)
  surveyName: TranslatedObjectModel | null;
  @Expose()
  @Transform(({ obj }) => (obj && obj?.surveyName && obj?.surveyName?._id ? obj.surveyName._id : null))
  surveyId: string | null;
  @Expose()
  @Transform(({ obj }) => (obj && obj?.studentId && obj?.studentId?._id ? obj?.studentId?._id : null))
  studentId: string;
  @Expose()
  @Transform(({ obj }) => (obj && obj?.studentId && obj?.studentId?.fullName ? obj?.studentId?.fullName : null))
  studentName: string;
  @Expose()
  @Transform(({ value }) =>
    value && typeof value == 'string'
      ? [value]
      : value && typeof value == 'object' && Array.isArray(value)
      ? value
      : null
  )
  questionsAnswers: string[];
}
